/**
 * Created by agengmaulana on 4/28/17.
 */
import React from 'react'
import styles from './../../assets/css/comment.css'

export default class Comment_Profile_Image extends React.Component {

    constructor(props) {
        super(props);
        this.state={
            mr10: this.props.mr10,
        }
    }


    render() {
        let data = this.state.mr10 == 'false' ? '' : styles.cmt_mr10
        return (
            <span className={styles.cmt_ratiobox +' '+ styles.cmt_box_img+' '+data}>
                <span className={styles.cmt_ratiobox_content +' '+'lqd'+' '+styles.cmt_circle}>
                    <img src={this.props.photo} onError={(e)=>{e.target.src="https://connect.detik.com/assets/images/default.png"}} alt={this.props.nickname} />
                </span>
            </span>
        )
    }
}


// WEBPACK FOOTER //
// ./static/src/component/comment_profile_image/comment_profile_image.js